import { Pipe, PipeTransform, inject } from '@angular/core';
import { remove } from 'remove-accents'; 'remove-accents'
import { ArticuloDTO } from 'src/app/Models/ApiV2/ArticuloDTO';
import { CategoriaDTO } from 'src/app/Models/ApiV2/CategoriaDTO';
import { FamiliaArticuloDTO } from 'src/app/Models/ApiV2/FamiliaArticuloDTO';
import { MarcaDTO } from 'src/app/Models/ApiV2/MarcaDTO';
import { VariablesGlobalesService } from '../../../services/variables-globales.service';
const lodash = require('lodash');

@Pipe({
    name: 'buscarCategoriasArticulos',
    standalone: true
})
export class BuscarFiltrosArticulosPipe implements PipeTransform {
  variablesGlobales = inject(VariablesGlobalesService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  //constructor(...args: unknown[]);


  constructor() { }




  transform(array: ArticuloDTO[],
    categoriasArticulosSeleccionadas?:CategoriaDTO[],
    familiasArticulosSeleccionadas?:FamiliaArticuloDTO[],
    marcasArticulosSeleccionadas?: MarcaDTO[],
  ): ArticuloDTO[] {
    //console.log('categoriasArticulosSeleccionadas: ',categoriasArticulosSeleccionadas);
    //console.log('familiasArticulosSeleccionadas: ',familiasArticulosSeleccionadas);
    //console.log('marcasArticulosSeleccionadas: ', marcasArticulosSeleccionadas);

    // if (texto === '') {
    //   return array;
    // }

    if (!array) {
      return array;
    }


    let arrayFiltradoCategorias:ArticuloDTO [] = []
    if(categoriasArticulosSeleccionadas.length!=0){
      lodash.filter(array, function(articulo:ArticuloDTO){
        if(articulo?.categorias && articulo?.categorias.length != 0){
          articulo?.categorias.filter(catArticulo => {
            if(lodash.some(categoriasArticulosSeleccionadas,{'id':catArticulo?.id})){
              if(!arrayFiltradoCategorias.includes(articulo)){
                arrayFiltradoCategorias.push(articulo)
                return
              }

            }
          })
        }else{
          return
        }
      })
    }else{
      arrayFiltradoCategorias = array
    }
    //console.log('arrayFiltradoCategorias: ',arrayFiltradoCategorias);


    let arrayFiltradoFamilias:ArticuloDTO [] = []
    if(familiasArticulosSeleccionadas.length!=0){
      lodash.filter(arrayFiltradoCategorias, function(articulo:ArticuloDTO){
        if(lodash.some(familiasArticulosSeleccionadas, {'id':articulo?.familia?.id})){
          if(!arrayFiltradoFamilias.includes(articulo)){
            arrayFiltradoFamilias.push(articulo)
            return
          }

        }

      })
    }else{
      arrayFiltradoFamilias = arrayFiltradoCategorias
    }
    //console.log('arrayFiltradoFamilias: ',arrayFiltradoFamilias);


    let arrayFiltradoMarcas:ArticuloDTO [] = []
    if(marcasArticulosSeleccionadas.length!=0){
      lodash.filter(arrayFiltradoFamilias, function(articulo:ArticuloDTO){
        if(lodash.some(marcasArticulosSeleccionadas, {'id':articulo?.marca?.id})){
          if(!arrayFiltradoMarcas.includes(articulo)){
            arrayFiltradoMarcas.push(articulo)
            return
          }

        }

      })
    }else{
      arrayFiltradoMarcas = arrayFiltradoFamilias
    }

    console.log('arrayFiltradoMarcas: ',arrayFiltradoMarcas);

    return arrayFiltradoMarcas



    }





}
